<template>
  <div class="timing-history-container" v-if="parameter.visable">
    <el-dialog :visible.sync="parameter.visable" title="运行历史" width="700px" center :close-on-click-modal="false" @close="dialogClose" >
      <div class="dialog-content">
        <el-form :inline="true">
          <el-form-item label="开始时间" prop="startDateTime">
            <el-date-picker
              v-model="timeFilter.startDateTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="请选择时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endDateTime">
            <el-date-picker
              v-model="timeFilter.endDateTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="请选择时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="search-button" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="table">
          <el-table :data="tableData" v-loading="loading" height="100%" header-row-class-name="header-class" :cell-style='cellStyle'>
            <el-table-column prop="jobName"
                             label="定时操作名称"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="operationTime"
                             label="操作时间"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="result"
                             label="运行结果"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <div  class="pagination-footer footer-content">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizes"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next, sizes"
          :total="pagination.total">
                  </el-pagination>
          </div>
        <el-button @click="dialogClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['parameter'],
  name: 'timing-history',
  data () {
    return {
      flag: 1,
      filters: {},
      timeFilter: {
        startDateTime: '',
        endDateTime: ''
      },
      tableData: [],
      loading: true,
      pagination: {currentPage: 1, pageSize: 10, pageSizes: [10, 20, 30, 50, 100], total: 0}
    }
  },
  methods: {
    loadList () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      if (this.flag) {
        const today = this.getToday()
        this.filters.startDateTime = today + ' 00:00:00'
        this.filters.endDateTime = today + ' 23:59:59'
        this.timeFilter.startDateTime = today + ' 00:00:00'
        this.timeFilter.endDateTime = today + ' 23:59:59'
        params.filters = this.filters
      } else {
        params.filters = this.filters
      }
      this.flag = null
      this.$axios.get(`/task-api/quartz/jobRuHistory/${this.parameter.id}`, {params}).then(res => {
        this.pagination.total = res.data.total
        if (this.pagination.total && (this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
          this.pagination.currentPage--
          return
        }
        this.tableData = res.data.items || []
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'startDateTime': this.timeFilter.startDateTime,
        'endDateTime': this.timeFilter.endDateTime
      }
      this.loadList()
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      if (column.property === 'result') {
        if (row[column.property] === '失败') {
          return `color:#F64D5E`
        }
      }
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.loadList()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.loadList()
    },
    getToday () {
      let today = new Date()
      let year = today.getFullYear()
      let month = today.getMonth() + 1
      month = month >= 10 ? month : '0' + month
      let day = today.getDate()
      day = day >= 10 ? day : '0' + day
      return year + '-' + month + '-' + day
    },
    dialogClose () {
      this.timeFilter.startDateTime = ''
      this.timeFilter.endDateTime = ''
      this.parameter.visable = false
    }
  },
  watch: {
    'parameter.visable' (val) {
      if (val) {
        this.flag = 1
        this.pagination.currentPage = 1
        this.pagination.pageSize = 10
        // let url = `/task-api/quartz/jobRuHistory/${this.parameter.id}`
        try {
          this.loadList()
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
.timing-history-container {
  & > .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__body {
        padding: 20px 20px 0 20px;
      }
      .footer-content{
        display: flex;
        justify-content: flex-end
      }
      .dialog-content {
        .el-input{
          width: 160px;
        }
        .search-button {
          width:40px;
          height:24px;
          border: 1px solid #55ACF1;
          color: #55ACF1;
          padding: 0;
          border-radius:4px;
          margin-left: 18px;
        }
        & > .table {
          height: 320px;
        }
      }
      .el-dialog__footer {
        padding: 20px 0 28px 0;
        .el-button {
          width:84px;
          height:26px;
          border-radius:4px;
          padding: 0;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/system/system/timing-history.vue